/*
Copyright 2017 Michael Telatynski <7t3chguy@gmail.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

'use strict';

import React from 'react';
import PropTypes from 'prop-types';

export default class GenericTextContextMenu extends React.Component {
    static PropTypes = {
        message: PropTypes.string.isRequired,
    };

    render() {
        return <div>{ this.props.message }</div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/views/context_menus/GenericTextContextMenu.js